import { Button, Col, Form, message, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/';
import queryString from 'query-string';
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import SortableList from '../components/SortableList';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import ZenFormInput from './InputCreater/ZenFormInput';
import StAddNew from './DSeries/StAddNew';

// import { RiDragMove2Line } from 'react-icons/ri';

const ZenSortableList = ({
    setPageHeader
}) => {
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [selectedItems, setSelectedItems] = useState([]);
    const [pageData, setPageData] = useState();
    const [config, setConfig] = useState()
    const [pageLoading, setPageLoading] = useState(true);

    const [form] = Form.useForm();
    const LocalDict = [];
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker", "slicer"];
    const [items, setItems] = useState([
        {
            _id: 1,
            name: 'Kristina Zasiadko',
            image: 'https://media.geeksforgeeks.org/wp-content/uploads/20230816223829/geeksgforgeeks-logo-1.png',
        },
        {
            _id: 2,
            name: 'John Doe',
            image: 'https://media.geeksforgeeks.org/wp-content/uploads/20230721212159/gfg-logo.jpeg',
        },
        {
            _id: 3,
            name: 'Jane Smith',
            image: 'https://media.geeksforgeeks.org/wp-content/uploads/20230909123918/GeeksforGeeks-Wide-logo-black.png',
        },
        // Add more items here
    ]);
    const [formData, setFormData] = useState();
    const [draggingItem, setDraggingItem] = useState(null);

    const handleDragStart = (e, item) => {
        setDraggingItem(item);
        e.dataTransfer.setData('text/plain', '');
    };

    const handleDragEnd = () => {
        setDraggingItem(null);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const selectItem = (e, item) => {
        if (e.ctrlKey || e.metaKey) {
            if (checkItemInBag(item)) {
                setSelectedItems(selectedItems.filter(x => x._id !== item._id));
            } else {
                setSelectedItems([...selectedItems, item]);
            }
        } else {
            setSelectedItems([item]);
        }
    }

    const getData = () => {
        liracrypt.get('/textapi', { ...searchParams })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setPageData(data.data);
                    setConfig(data.config);
                    setPageLoading(false);
                } else {
                    message.error(data.message);
                }
            }).catch(err => {
                console.log(err);
                ApiErrorComp();
            })
    };

    const onFinish = (value) => {
        setFormData(null);
        Object.keys(value).forEach((key, i) => {

            if (value[key]) {
                if (Array.isArray(value[key]) && LocalDict[key]) {
                    value[
                        LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
                    ] = dayjs(value[key][0]).format(LocalDict[key]).toString();
                    value[
                        LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"
                    ] = dayjs(value[key][1]).format(LocalDict[key]).toString();
                    delete value[key];
                } else {
                    if (LocalDict[key]) {
                        value[key] = dayjs(value[key]).isValid()
                            ? dayjs(value[key]).format(LocalDict[key]).toString()
                            : value[key];
                    }
                    // } else {
                    //   value[key] = moment(value[key]).isValid()
                    //     ? moment(value[key]).toString()
                    //     : value[key];
                    // }
                }
            }
        });

        Object.keys(value).forEach((element) => {
            if (Array.isArray(value[element])) {
                let filtered = value[element].filter(function (el) {
                    return el != null;
                });
                let temp = filtered.toString();
                value[element] = "[" + temp + "]";
            }
        });
        setTimeout(() => {
            setFormData({ ...searchParams, ...value });
        }, 300);
    };

    const queryElements = (data, index) => {
        if (data.visible !== false) {
            return (
                <React.Fragment key={index}>
                    <ZenFormInput
                        queryLayout={config.queryLayout}
                        pageType={"phantom"}
                        onChange={(data.typ === 'dropDown' && data.submitOnChange) ? () => form.submit() : undefined}
                        // layoutPosition={layoutPosition}
                        colSpan={data.colSize || 12}
                        form={form}
                        name={data["data_index"]}
                        pname={data["p_data_index"]}
                        label={data["label"]}
                        defaultValue={data["default"]}
                        defaultFrom={data["defaultFrom"]}
                        defaultTo={data["defaultTo"]}
                        typ={data["typ"]}
                        disabled={data["readOnly"]}
                        source={data["source"]}
                        sourceParams={data["sourceParams"]}
                        auxParams={data["auxParams"]}
                        format={data["format"]}
                        errorMessage={data["errorMessage"]}
                        placeHolder={data["placeHolder"]}
                        required={data["required"]}
                        options={data["data"]}
                        from={data["data_index_from"]}
                        to={data["data_index_to"]}
                        url={data["url"]}
                        includeAll={data["includeAll"]}
                        multiSelect={data["multiSelect"]}
                        // searchable={data["isSearchable"]}
                        searchable={true}
                        data={data}

                    />
                </React.Fragment>
            )
        }
    }

    const checkItemInBag = (item) => {
        let itemInBag = selectedItems.find(x => x._id === item._id);
        if (itemInBag) return true;
        return false;
    }

    const sortableList = (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <SortableList pageConfig={config} data={pageData} api={config?.api || '/textapi'} urlData={{ ...searchParams, ...config?.params, ...formData }} />
        </div>
    )

    useEffect(() => {
        setPageHeader('Zen Sortable List')
        setPageLoading(true);
        if (searchParams?.isNew) {
            setPageLoading(false);
            return
        };
        getData();
    }, []);


    return (
        <>
            {/* <SessionError loginError={loginError} /> */}
            <div className={''}>
                {
                    pageLoading ?
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignContent: 'center',
                            alignItems: 'center',
                            width: '100%'
                        }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} spin />} />
                        </div> :
                        // <>
                        //     {config?.output?.respTyp === 'query' ? (
                        //         <div>
                        //             <div className='phantom-form'>
                        //                 <StAddNew
                        //                     initForm={form}
                        //                     formName={"PmsElement"}
                        //                     colSpan={12}
                        //                     stopResetForm={true}
                        //                     urlEndpoint="/miscellaneous/pageconfig"
                        //                     urlData={{ dictName: "PmsElement" }}
                        //                     extraData={{}}
                        //                     onFormSubmit={(data) => console.log(data)}
                        //                 />
                        //                 <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                        //                     <Button htmlType='submit' type="primary" form={'PmsElement'}>Submit</Button>
                        //                 </div>
                        //             </div>
                        //         </div>

                        //     ) : (
                        //         <>{sortableList}</>
                        //     )}
                        // </>
                        <>
                            {
                                searchParams?.isNew ?
                                    <div>
                                        <div className='phantom-form'>
                                            <StAddNew
                                                initForm={form}
                                                formName={"PmsElement"}
                                                setConfig={(config) => setConfig(config)}
                                                colSpan={12}
                                                stopResetForm={true}
                                                urlEndpoint="/miscellaneous/pageconfig"
                                                urlData={{ dictName: "PmsElement" }}
                                                extraData={{}}
                                                onFormSubmit={(data) => setFormData(data)}
                                            />
                                            <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                                <Button htmlType='submit' type="primary" form={'PmsElement'}>Submit</Button>
                                            </div>
                                            {
                                                formData && (
                                                    <>{sortableList}</>
                                                )
                                            }
                                        </div>
                                    </div>
                                    : <>
                                        {sortableList}
                                    </>
                            }
                        </>
                }
            </div>

        </>

    );
};

export default ZenSortableList;
